import { getTextWidth } from "./platform";

interface Params {
    name: string;
    maxWidth: number;
    prefix?: string;
    font: string;
}

// TODO: Optimize this function from O(n) to O(log n)
function getTruncatedName({ name, maxWidth, prefix = "", font }: Params) {
    let truncatedName = name;
    let nameToRender = name;

    while (Math.floor(getTextWidth(`${prefix}${nameToRender}`, font)) > maxWidth) {
        const cutIndex = Math.floor(truncatedName.length / 2);
        const leftHalf = truncatedName.substring(0, cutIndex);
        const rightHalf = truncatedName.substring(cutIndex + 1);
        nameToRender = `${leftHalf}…${rightHalf}`;
        truncatedName = `${leftHalf}${rightHalf}`;
    }

    return nameToRender;
}

// TODO-kenan: Add unit tests for getTruncatedNameStartingWithEllipsis
function getTruncatedNameStartingWithEllipsis({ name, maxWidth, font }: Params) {
    const textWidth = (text: string) => Math.ceil(getTextWidth(text, font));

    if (textWidth(name) <= maxWidth) {
        return name;
    }

    let left = 0;
    let right = name.length;
    let nameToRender = name;

    while (left < right) {
        // eslint-disable-next-line no-magic-numbers
        const mid = Math.floor((left + right) / 2);
        const truncatedName = name.substring(name.length - mid);
        const testWidth = textWidth(`…${truncatedName}`);

        if (testWidth <= maxWidth) {
            nameToRender = truncatedName;
            left = mid + 1;
        } else {
            right = mid;
        }
    }

    return `…${nameToRender}`;
}

// Returns the longest text that fits within maxWidth, breaking on word boundaries. Falls back to character boundaries if the first word exceeds maxWidth.
// e.g. "¿Dónde está la biblioteca?" → "¿Dónde está la"
// e.g. "Hippopotomonstrosesquippedaliophobia" → "Hippopotomonstrosesqu"
function getLineByWords(text: string, font: string, maxWidth: number): string {
    const words = text.split(" ");
    const [firstWord] = words;

    if (Math.ceil(getTextWidth(firstWord, font)) >= maxWidth) {
        let line = "";
        for (const char of text) {
            if (Math.ceil(getTextWidth(line + char, font)) >= maxWidth) {
                break;
            }

            line += char;
        }

        return line;
    }

    let line = "";
    for (const word of words) {
        const candidate = line ? `${line} ${word}` : word;
        if (Math.ceil(getTextWidth(candidate, font)) >= maxWidth) {
            break;
        }

        line = candidate;
    }

    return line;
}

// Truncates text from the start with a leading ellipsis to fit within maxWidth, or returns text as-is if it already fits.
// e.g. "¿Dónde está la biblioteca?" → "…la biblioteca?"
function getLineWithLeadingEllipsis(text: string, font: string, maxWidth: number): string {
    if (Math.ceil(getTextWidth(text, font)) <= maxWidth) {
        return text;
    }

    const chars = [...text];
    let tail = "";
    for (let i = chars.length - 1; i >= 0; i--) {
        const candidate = `…${chars[i]}${tail}`;
        if (Math.ceil(getTextWidth(candidate, font)) >= maxWidth) {
            break;
        }

        tail = `${chars[i]}${tail}`;
    }

    return `…${tail}`;
}

export default getTruncatedName;
export {
    getTruncatedNameStartingWithEllipsis,
    getLineByWords,
    getLineWithLeadingEllipsis
};
